import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Download, FileText, BookOpen, TrendingUp, BarChart3 } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Downloads = () => {
  const downloads = [
    {
      icon: FileText,
      title: 'Checkliste: Unterlagen für den Verkauf',
      description: 'Vollständige Checkliste aller notwendigen Unterlagen für einen professionellen Verkaufsprozess. Von Grundbuchauszug bis Mietverträge.',
      file: '/checkliste_unterlagen.pdf',
      pages: '3 Seiten'
    },
    {
      icon: BookOpen,
      title: 'Guide: WAULT optimieren',
      description: 'Strategien zur Verlängerung der Mietvertragslaufzeiten (WAULT) und Steigerung des Verkaufspreises um 10-20%.',
      file: '/guide_wault.pdf',
      pages: '4 Seiten'
    },
    {
      icon: TrendingUp,
      title: 'Ratgeber: 7 häufigste Fehler beim Verkauf',
      description: 'Vermeiden Sie kostspielige Fehler beim Verkauf Ihrer Handelsimmobilie. Praxisnahe Tipps von Experten.',
      file: '/ratgeber_7_fehler.pdf',
      pages: '5 Seiten'
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Downloads – Kostenlose Guides & Reports | RetailInvest"
        description="Kostenlose Downloads: Checklisten, WAULT-Guide, Fehler-Ratgeber und Marktreport für Handelsimmobilien."
        url="/downloads"
      />
      <Navbar />
      <main className="flex-grow bg-gray-50 py-12">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="w-20 h-1 bg-gradient-to-r from-[#D4A853] to-[#F0C870] mb-6 mx-auto"></div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: 'var(--navy-900)' }}>
              Ihre kostenlosen Downloads
            </h1>
            <p className="text-lg max-w-3xl mx-auto" style={{ color: 'var(--gray-700)' }}>
              Exklusive Guides, Checklisten und Reports für den erfolgreichen Verkauf Ihrer Handelsimmobilie.
            </p>
          </div>

          {/* Downloads Grid */}
          <div className="grid gap-6 mb-12">
            {downloads.map((item, index) => {
              const Icon = item.icon;
              return (
                <Card key={index} className="glass-card p-8 hover:shadow-xl transition-all duration-300">
                  <div className="flex flex-col md:flex-row gap-6 items-start">
                    <div 
                      className="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0"
                      style={{ background: 'linear-gradient(135deg, #0F2744 0%, #2563A0 100%)' }}
                    >
                      <Icon className="h-8 w-8 text-white" />
                    </div>
                    
                    <div className="flex-1">
                      <h3 className="text-xl font-bold mb-2" style={{ color: 'var(--navy-800)' }}>
                        {item.title}
                      </h3>
                      <p className="text-base mb-4" style={{ color: 'var(--gray-700)' }}>
                        {item.description}
                      </p>
                      <p className="text-sm mb-4" style={{ color: 'var(--gray-500)' }}>
                        📄 {item.pages}
                      </p>
                    </div>
                    
                    <a href={item.file} download className="flex-shrink-0">
                      <Button className="btn-gold-gradient text-white font-semibold">
                        <Download className="h-4 w-4 mr-2" />
                        PDF herunterladen
                      </Button>
                    </a>
                  </div>
                </Card>
              );
            })}
          </div>

          {/* Additional Info */}
          <Card className="glass-card p-8 bg-blue-50">
            <h3 className="text-xl font-bold mb-4" style={{ color: 'var(--navy-800)' }}>
              💡 Haben Sie Fragen?
            </h3>
            <p className="mb-4" style={{ color: 'var(--gray-700)' }}>
              Unser Team steht Ihnen für eine persönliche Beratung zur Verfügung.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="tel:+4981611851360">
                <Button variant="outline" className="font-semibold">
                  📞 08161 1851360
                </Button>
              </a>
              <Link to="/kontakt">
                <Button className="bg-[#2563A0] text-white hover:bg-[#1B4D7A]">
                  Kontaktformular
                </Button>
              </Link>
            </div>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Downloads;